import { fetchResource, fetchResourceUnauthenticated } from "./HALClient";
import logErrorEvent from "../util/logErrorEvent";
import apiRoot from "./apiRoot";

// eslint-disable-next-line no-confusing-arrow
var getFetcher = function getFetcher(unauthenticated) {
  return unauthenticated ? fetchResourceUnauthenticated : fetchResource;
};
export var startSurvey = function startSurvey(surveyId) {
  var unauthenticated = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var BASE_URL = apiRoot(window.location.hostname);
  var urlPrefix = unauthenticated ? "survey/v2/survey" : "survey/survey";
  var fetcher = getFetcher(unauthenticated);
  return fetcher("".concat(BASE_URL, "/").concat(urlPrefix, "/").concat(surveyId, "/start")).then(function (responseData) {
    return responseData;
  })["catch"](function (error) {
    logErrorEvent(error);
    throw error;
  });
};
export var submitPage = function submitPage(url, data) {
  var unauthenticated = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
  var fetcher = getFetcher(unauthenticated);
  return fetcher(url, {
    method: "POST",
    headers: {
      Accept: "application/hal+json",
      "Content-Type": "application/json"
    },
    body: JSON.stringify(data)
  }).then(function (responseData) {
    return responseData;
  })["catch"](function (error) {
    logErrorEvent(error);
    throw error;
  });
};